<script lang="ts">
	import { twJoin } from "tailwind-merge";
	import type { LandingPage } from "#gen/bundles/v1/bundle_pb.js";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import ConversionCard from "#lib/components/flow/viewer/desktop/ConversionCard.svelte";
	import type { LayoutProps } from "#lib/components/flow/viewer/layout/types.js";
	import PageBackgroundLayer, { hostBackgroundStyle } from "#lib/components/page/PageBackgroundLayer.svelte";
	import { APP_ANCHOR_NAME, CONVERSION_ANCHOR_NAME } from "#lib/dag.js";

	const { container: landingPage, mode, backgroundPaint = "inline", numApps = 0, hasPrimaryConversion = true, shouldPromoteFirstApp = false, style, share, conversion: nestedConversion, apps, accessory, isLightBackground, footer }: LayoutProps<LandingPage> = $props();
	const hasApps = $derived(numApps > 0);
</script>

<div class={twJoin("flex h-full flex-col justify-center", mode !== Mode.EDITING && "@sm:flex")} {style}>
	<div style={hostBackgroundStyle(backgroundPaint)} class={twJoin("flex w-full flex-1 flex-col bg-white pt-2", backgroundPaint === "layer" && "relative isolate")}>
		{#if backgroundPaint === "layer"}<PageBackgroundLayer />{/if}
		{@render share?.()}
		<div class={twJoin("flex flex-col", !hasApps && "justify-center", typeof share === "function" && "mt-2")}>
			<ConversionCard {landingPage} {hasPrimaryConversion} {shouldPromoteFirstApp} {isLightBackground}>
				{#snippet conversion()}
					<div class="relative">
						{@render nestedConversion?.()}
						{@render accessory?.[CONVERSION_ANCHOR_NAME]?.()}
					</div>
				{/snippet}
			</ConversionCard>
			{#if hasApps && !(shouldPromoteFirstApp && numApps === 1)}
				<div class="mb-8 w-full border-b border-black/20"></div>
				<div class="relative">
					{@render apps?.()}
					{@render accessory?.[APP_ANCHOR_NAME]?.()}
				</div>
			{/if}
		</div>
	</div>
	{@render footer?.(mode)}
</div>
